import React from 'react';
import { Link } from 'react-router-dom';

const Impressum = () => {
  return (
    <div className="min-h-screen bg-white py-20">
      <div className="max-w-2xl mx-auto px-6">
        <Link to="/" className="text-xs uppercase tracking-widest text-gray-400 hover:text-gray-800 mb-12 inline-block">← Zurück</Link>
        
        <div className="prose prose-sm prose-gray">
          <h1 className="text-2xl font-light mb-12">Impressum</h1>
          
          <p className="font-medium">Angaben gemäß § 5 TMG</p>
          <p>
            Nadine Rau u. Mike Trepte GbR<br />
            Bettenhäuserstr. 1<br />
            34123 Kassel<br />
            Deutschland
          </p>

          <p className="font-medium mt-8">Geschäftsführer</p>
          <p>Nadine Rau, Mike Trepte</p>

          <p className="font-medium mt-8">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</p>
          <p>Mike Trepte</p>

          <p className="font-medium mt-8">Kontakt</p>
          <p>
            Telefon: 0561 / 43027276<br />
            E-Mail: mike@underopensky.de
          </p>
          <p>Standort: Kassel, Deutschland</p>

          <p className="font-medium mt-8">Umsatzsteuer-ID</p>
          <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE338605405</p>

          <p className="font-medium mt-8">Redaktionell verantwortlich</p>
          <p>
            Mike Trepte<br />
            Bettenhäuserstr. 1<br />
            34123 Kassel
          </p>

          <h3 className="mt-8 font-medium">Haftung für Inhalte</h3>
          <p className="text-xs text-gray-500">
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;